import { SchoolGiveWidget } from '../common/SchoolGiveWidget';

interface WrappedSchoolGiveWidgetProps {
    // Our preexisting types declare that this should be a numeric string, but in practice on the pages where I've
    // tested it it's actually a number. I'm not going to get into it right now.
    favoriteValue: string | number,
    callToActionDisplayName: string,
    monthlySchoolDonationEnabled: boolean,
}

/**
 * A SchoolGiveWidget with a few props filled in based on the values present on the school page. Extracted from
 * CallToActionWidget.
 */
export const WrappedSchoolGiveWidget = ({ favoriteValue, callToActionDisplayName, monthlySchoolDonationEnabled }: WrappedSchoolGiveWidgetProps) => {
    return (
        <div className="favorite-link-wrapper">
            <SchoolGiveWidget schoolId={favoriteValue} schoolName={callToActionDisplayName} useAjax={true} monthlySchoolDonationEnabled={monthlySchoolDonationEnabled} useLightbox={true} />
        </div>
    );
};
